<button [type]="type" class="rounded px-3 py-1 shadow transition-all duration-150">
  <ng-content></ng-content>
</button>
